import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {MvsSearchFlexibleResultData} from "./mvs-search-flexible-result.data";
import {DtoDetail} from "../dto/dto.detail";

@Component({
    selector: 'mvs-search-flexible-base-component-interface',
    template: 'Base Component',
    standalone: false
})
export class MvsSearchFlexibleBaseComponent
        implements OnChanges {

    @Input() objectType: string;

    @Input() defaultDto: DtoDetail;

    @Input() isToolingArea: boolean;

    @Output() onObjectSelect: EventEmitter<MvsSearchFlexibleResultData> = new EventEmitter<MvsSearchFlexibleResultData>();

    @Output() onSearchAction: EventEmitter<any> = new EventEmitter<any>;

    initialized: boolean = false;
    busy: boolean = false;


    refreshComponent() {

    }

    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["objectType"]) {
            this.refreshComponent();
        }

    }


}
